





import { getVuxUrlQuery, createRequest } from "../../utils/utils";
var player = new Audio();
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import HumanList from "../HumanList/HumanList.vue";
import PaymentModel from "../PaymentModel/PaymentModel.vue";
import { STORAGE_KEY } from "../../utils/define";
import {
modelView,
config,
chatRechargeConfig,
getChatStat,
cardView,
setCard,
getPublicsAudio,
setImage
} from "../../api/api";
import AddQa from "../../myComponents/AddQa/AddQa.vue";
import QAComponent from "../../myComponents/QAComponent/QAComponent.vue";
export default {
name: "chatframe",
components: {
Flexbox,
FlexboxItem,
Divider,
Grid,
GridItem,
GroupTitle,
XTextarea,
Group,
XInput,
HumanList,
QAComponent,
AddQa,
PaymentModel,
},
props: {
modelID: Number | String,
cardTypeIs: String,
firmIdBol:String | Number








},
data() {
return {
spareList: [],
spareTotal: 0,
administrationSpareType: 0,
preComponentsState: "",
componentsState: "",
textareaValueLength: 0,
textareaValue: "",
tagList: [],
toneList: [],
toneId: 0,
toneState: 1,
tagValue: "",
addTagModelIsOpen: false,
tagHeight: 0,
modelViewId: 0,
addSaveRouter: 1,
movementList: [], //动作
tabList: [
{
id: 1,
name: "数字人形象",
is_show: 1,
},
{
id: 2,
name: "互动设置",
is_show: 2,
},
{
id: 3,
name: "互动问题",
is_show: 0,
},
],
qaPageShow: 1,
setCostType: 0,
purchaseModelIsopen: false,
purchaseList: [],
hintIsopneModel: false,
notYetSetQaState: false, // 尚未设置qa
careObj: null,
gender: 0,
isHasConsume: false,
firmIdBolActive:this.firmIdBol,
};
},
mounted() {






},
created() {

this.modelViewId =
this.modelID || localStorage.getItem(STORAGE_KEY.MODEL_ID);
this.initSpareInfo().then((data) => {
this.getMovementTone(data.version);
});

this.getPurchaseConfing();
getChatStat().then((res) => {
if (res.data.char_num_use > 0) this.isHasConsume = true;
else this.isHasConsume = false;
});
},
beforeDestroy() {},
methods: {

onAuditionUrl()
{
player.pause();
this.$vux.loading.show({
text: "请等待",
});
getPublicsAudio(this.textareaValue,this.toneId).then(res=>{
console.log('%c⧭', 'color: #f200e2', )
player.src = res.data.audio_url;
this.$vux.loading.hide();
player.play();
})
},

inputClick() {
console.log("input focus");
this.$refs.messageInput.focus();
},

informCancelPurchase(e) {
this.purchaseModelIsopen = e;
this.setCostType = 1;
},
informImmediatelyPurchase(e) {
if (e) {

this.purchaseModelIsopen = false;
this.$vux.toast.show({
type: "text",
text: "充值成功",
});
}
},

onCloseHintModel() {
this.hintIsopneModel = false;
},

onOpenHintModel() {
this.hintIsopneModel = true;
},

getPurchaseConfing() {
chatRechargeConfig().then((res) => {
this.purchaseList = res.data.recharge_config[0];

console.log("%c⧭", "color: #33cc99;font-size:99px", this.purchaseList);
});
},

onCostSelect(e) {
this.setCostType = e;
if (e == 2) {


getChatStat().then((res) => {
if (res.data.char_num < 10) {
this.purchaseModelIsopen = true;
}
});
}
},
onAQListChange(event) {
if (event.modelViewId == this.modelViewId) {
this.hasQAList == event.total > 0;
}
},

getMovementTone(version) {
config(version).then((res) => {
this.toneList = res.data.audio_timbre_map[String(this.gender)];
});
},
initSpareInfo() {
return new Promise((resolve, reject) => {
console.log("initSpareInfo", this.modelViewId, this.cardTypeIs);
if (this.cardTypeIs == "3d") {
modelView(this.modelViewId).then((res) => {
this.textareaValue = res.data.image.greet;

this.toneId = res.data.image.audio_timbre;
this.setCostType = res.data.image.chat_type || 1;
this.gender = res.data.image.gender;
this.$emit("onSpareInfoChange", res.data);
localStorage.setItem(STORAGE_KEY.MODEL_NAME, res.data.image.name);
resolve(res.data.image);
});
} else if (this.cardTypeIs == "2d") {
cardView(this.modelViewId).then((res) => {
console.log("%c⧭", "color: #99614d;font-size:200px", res.data);
this.textareaValue = res.data.card.greet;
this.careObj = res.data;

this.toneId = res.data.card.chat_audio_timbre?res.data.card.chat_audio_timbre: res.data.card.audio_timbre;
this.setCostType = res.data.card.chat_type || 1;
this.gender = res.data.card.gender;
localStorage.setItem(STORAGE_KEY.MODEL_NAME, res.data.card.name);
this.$emit("onSpareInfoChange", res.data);
resolve(res.data.card);
});
}
});
},

getFigureList() {
console.log("--------------------------set com getFigureList");
createRequest(
"get",
"applet/user/image/list",
{ page: 1, num: 100, status: 3 },
(res) => {
console.log("%c⧭", "color: #d90000;font-size:300px", res.data.data);
if (res.code == 200) {
this.spareList = res.data.data;
this.spareTotal = res.data.total;
} else {
console.error(res.msg);
this.$vux.toast.show({
type: "text",
text: res.msg,
});
}
}
);
},

onAdministrationSpare(e) {
this.administrationSpareType = e;

console.log("%c⧭", "color: #ffa280", this.administrationSpareType);
},

onSetPerson(val) {
this.tagList.forEach((item) => {
if (item.id == val.id) {
item.dis = !item.dis;
}
});
},
onEvent(event) {
console.log("on", event);
},
onToneActive(item) {
console.log('-----',this.toneId,this.toneState)
let id = item.id;
let _this = this;
if (id != this.toneId) {
this.toneId = id;
this.toneState = 1;
player.pause();
} else if (this.toneId == id && this.toneState == 1) {
this.toneState = 2;
player.src = item.audio_url;
player.play();
player.addEventListener(
"ended",
function () {
console.log("播放结束");
_this.toneState = 3;
if (_this.toneState == 3) {
_this.toneState = 1;
}
},
false
);
} else if (this.toneId == id && this.toneState == 2) {
this.toneState = 3;
player.pause();
if (this.toneState == 3) {
this.toneState = 1;
}
}
},
async onSaveSet() {


return new Promise((resolve,reject)=>{
if (this.textareaValueLength < 10) {
this.$vux.toast.show({
type: "text",
text: "请按要求设置打招呼内容,最少设置10个字符",
});
return reject()

}
if (this.toneId == 0) {
this.$vux.toast.show({
type: "text",
text: "请选择音色",
});
return reject()
}
if (this.setCostType == 0) {
this.$vux.toast.show({
type: "text",
text: "请选择对话机器人",
});
return reject()
}
this.$vux.loading.show({
text: "正在设置",
});
if (this.cardTypeIs == "3d") {
console.log(this.firmIdBolActive,'this.firmIdBolActive')

setImage({
image_id: this.modelViewId,
greet: this.textareaValue,
audio_timbre: this.toneId,
chat_type:this.firmIdBol <=0 ? this.setCostType : undefined,
}).then(d => {
this.$emit("onSpareInfoChange", {
clearSetting: true,
});
this.$emit("onSaveSetRouter", {
modelViewId: this.modelViewId,
greet: this.textareaValue,
});
this.$vux.loading.hide();
resolve()
}, e => {
console.error(e);
this.$vux.toast.show({
type: "text",
text: e,
});
this.$vux.loading.hide();
reject()
})
} else if (this.cardTypeIs == "2d") {
let obj = {
card_id: this.modelViewId,
greet: this.textareaValue,
chat_audio_timbre: this.toneId,
chat_type: this.setCostType,
};

setCard(obj).then((res) => {
if (res.code == 200) {
this.$emit("onSpareInfoChange", {
clearSetting: true,
});
this.$emit("onSaveSetRouter", {
modelViewId: this.modelViewId,
greet: this.textareaValue,
});
resolve()
} else {
console.error(res.msg);
this.$vux.toast.show({
type: "text",
text: res.msg,
});
reject()
}
this.$vux.loading.hide();
console.log("%c⧭", "color: #40fff2", res);
});
}
})

},
onGetFocus() {},
onCloseModelIsOpen() {
this.addTagModelIsOpen = false;
this.tagValue = "";
},
onAddTagModelIsOpen() {
this.addTagModelIsOpen = true;
setTimeout(() => {
this.$refs.input.focus();
}, 100);
this.tagValue = "";
},
onBack() {
console.log("----QA back");
this.onSaveSet().then(()=>{
this.$emit("onBack", "preview");
},()=>{

})

},
onGotoConsumeRecord() {
console.log("跳转消耗明细");
this.$wechat.miniProgram.navigateTo({
url: "/walletPage/pages/chatConsumeRecord/chatConsumeRecord",
success: function () {
console.log("跳转成功");
},
});
},
},
watch: {
textareaValue(value) {
this.textareaValueLength = value.length;
console.log("%c⧭", "color: #73998c", value);
this.textareaValue = value;
},
modelID(value) {
console.log("%c⧭", "color: #7f2200", value);
if (this.modelViewId != value) {
this.modelViewId = value;
this.toneState = 1;
player.pause();
this.initSpareInfo().then((data) => {
this.getMovementTone(data.version);
});
}
},
firmIdBol(v)
{
this.firmIdBolActive = v
console.log('%c⧭', 'color: #006dcc', v)
}
},
};



// WEBPACK FOOTER //
// ./src/myComponents/setThreeCom/setThreeCom.vue